import { render } from "./VehiclesItem.vue?vue&type=template&id=a7d9cbe6"
import script from "./VehiclesItem.vue?vue&type=script&lang=js"
export * from "./VehiclesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__